import { BrandSelectionWidget, AttributeCategorySelectionWidget } from 'components/FormWidget';

const uiSchema = () => ({
  brand_id: {
    'ui:widget': BrandSelectionWidget,
  },
  category_id: {
    'ui:widget': AttributeCategorySelectionWidget,
  },
  introtext: {
    'ui:widget': 'textarea',
  },
});

export default uiSchema;
